<app-navbar title="Rezerwacje wycieczek"> </app-navbar>

<app-dynamic-table
	module="residentTrips/documents/ticket"
	[elements]="data"
	[tableRows]="tableRows"
></app-dynamic-table>
